var map = {
	"./calibri/Calibri-Bold-Italic.ttf": 259,
	"./calibri/Calibri-Bold.ttf": 260,
	"./calibri/Calibri-Italic.ttf": 261,
	"./calibri/Calibri-Light-Italic.ttf": 262,
	"./calibri/Calibri-Light.ttf": 263,
	"./calibri/Calibri-Regular.ttf": 264
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 258;